import { useQuery } from '@tanstack/react-query';
import {
  getCustomSurveyTemplates,
  type CustomSurveyTemplate,
} from '../../api/customSurveyTemplates';

export const useGetCustomSurveyTemplatesQuery = (params?: {
  teamId?: number;
  filterByUsage?: boolean;
}) => {
  return useQuery<CustomSurveyTemplate[]>({
    queryKey: ['custom-survey-templates', params],
    queryFn: () => getCustomSurveyTemplates(params),
  });
};
